'use client';

import InteractiveFigure, { LabelConfig } from './InteractiveFigure';
import RadSumFig from '@/assets/RadSumFig';

const RADSUM_LABELS: LabelConfig[] = [
  { id: 'a1', label: 'In-tunnel temperature/RH sensor', description: 'Works with the IR temperature sensor to calculate vapour pressure deficit at the leaf surface and help shape fertigation delivery.' },
  { id: 'a2', label: 'DripDrain sensor', description: 'Measures volume of drip and drain water, along with EC and pH for both.' },
  { id: 'a3', label: 'Drain channel', description: 'Aggregates water from the row.' },
  { id: 'a4', label: 'Node', description: 'Powers the sensors and sends data to the cloud.' },
  { id: 'a5', label: 'Substrate', description: 'Media optimized for the crop and climate.' },
  { id: 'a6', label: 'Drip emitters', description: 'Deliver fertigation water to the substrate.' },
  { id: 'a7', label: 'EC & soil moisture sensor', description: 'Measures electrical conductivity (EC), soil moisture, and temperature in the root zone. Used for planning fertigation.' },
  { id: 'a8', label: 'Dripline pressure sensor', description: 'Confirms that the dripline is pressurized and can alert you to dripline breaks or solenoid issues.' },
  { id: 'a9', label: 'IR temperature sensor', description: 'Measures leaf temperature to help assess crop stress and transpiration relative to the surrounding air.' },
  { id: 'a10', label: 'Weather station', description: 'Measures local wind, temperature, and precipitation to inform irrigation decisions.' },
  { id: 'a11', label: 'Pyranometer', description: 'Measures incoming solar radiation to help anticipate crop water demand.' },
];


export default function RadSumFigure() {
  return (
    <InteractiveFigure
      FigureComponent={RadSumFig}
      labels={RADSUM_LABELS}
      minWidth={600}
      centerOffset={0}
    />
  );
}
